import { STATUS_META, statusChipClass } from "@/lib/bill-utils";

export const StatusChip = ({ status, testid }) => {
  const meta = STATUS_META[status] || STATUS_META.unpaid;
  return (
    <span
      data-testid={testid || `status-chip-${status}`}
      className={`chip ${statusChipClass(status)}`}
    >
      {meta.label}
    </span>
  );
};

export default StatusChip;
